import {
  type RefinementListProps,
  useClearRefinements,
  useRefinementList } from
'react-instantsearch';
import { type MenuItem } from 'instantsearch.js/es/connectors/menu/connectMenu';

import {
  RadioGroup,
  RadioGroupItem } from
'~/components/OddscheckerPlus/components/cxy';

import styles from './styles/BetTypeFilters.module.css';

interface BetTypeFilterProps extends RefinementListProps {
  isDisabled?: boolean;
  label?: string;
}

export function BetTypeFilter({
  isDisabled = false,
  ...props
}: BetTypeFilterProps) {
  const { refine: clearRefinement } = useClearRefinements({
    includedAttributes: ['marketDisplayName']
  });
  const { items, refine } = useRefinementList(props);

  const handleValueChange = (value: string) => {
    clearRefinement();
    if (value.includes('Total')) {
      const newValues = value.replace('Total::', '').split('::');
      newValues.forEach((newValue) => {
        refine(newValue);
      });
    } else if (value !== 'all') {
      const newValue = value === 'all' ? '' : value;
      refine(newValue);
    }
  };

  if (!items.length) return null;

  return (
    <RadioGroup
      className={(styles.betTypeFilters, styles.select)}
      defaultValue={'all'}
      disabled={isDisabled}
      onValueChange={handleValueChange}>

			<RadioGroupItem id="all" key="all" value="all">
				All
			</RadioGroupItem>
			{items.
      reduce((agg, item) => {
        if (!item.label.includes('Total')) {
          return [...agg, item];
        } else if (
        agg.filter((aggItem) => aggItem.label === 'Total').length > 0)
        {
          const index = agg.findIndex((aggItem) => aggItem.label === 'Total');
          agg.splice(index, 1, {
            ...agg[index],
            value: `${agg[index].value}::${item.value}`
          });
          return agg;
        }
        return [
        ...agg,
        {
          ...item,
          label: 'Total',
          value: `Total::${item.value}`
        }];

      }, [] as MenuItem[]).
      map(({ isRefined, label, value }) =>
      <RadioGroupItem
        checked={isRefined}
        className={styles.select}
        id={value}
        key={value}
        value={value}>

						{label}
					</RadioGroupItem>
      )}
		</RadioGroup>);

}